import { Bleedable } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'
import { MARGIN_X_DEFAULT, MARGIN_Y_DEFAULT } from './common'

type Props = {
  children: ReactNode
}

export default function MergeSquareCardMarginBox({ children }: Props): JSX.Element {
  return (
    <Bleedable sides={MARGIN_X_DEFAULT} top={MARGIN_Y_DEFAULT} bottom={MARGIN_Y_DEFAULT}>
      {children}
    </Bleedable>
  )
}
